<template>
  <div class="agent-status-carousel" v-if="currentAgent">
    <transition
      name="flip"
      mode="out-in"
    >
      <div
        :key="currentAgent.sessionId"
        class="carousel-item"
        :style="{ color: currentAgent.statusColor }"
      >
        <span class="agent-name">{{ currentAgent.agentName }}</span>
        <span class="separator">: </span>
        <span class="status-text">{{ currentAgent.statusText }}</span>
        <span class="ellipsis">...</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AgentStatusCarousel',
  props: {
    activeAgents: {
      type: Array,
      required: true,
      default: () => []
    },
    interval: {
      type: Number,
      default: 3000 // 3秒切换一次
    }
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null
    };
  },
  computed: {
    currentAgent() {
      if (!this.activeAgents || this.activeAgents.length === 0) {
        return null;
      }
      return this.activeAgents[this.currentIndex];
    }
  },
  watch: {
    activeAgents: {
      handler(newVal) {
        // 重置索引如果列表变化
        if (!newVal || newVal.length === 0) {
          this.currentIndex = 0;
          this.stopRotation();
        } else if (this.currentIndex >= newVal.length) {
          this.currentIndex = 0;
        }

        // 如果有新的智能体列表，重新启动轮播
        if (newVal && newVal.length > 0 && !this.intervalId) {
          this.startRotation();
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.activeAgents && this.activeAgents.length > 0) {
      this.startRotation();
    }
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
    startRotation() {
      if (this.intervalId || !this.activeAgents || this.activeAgents.length <= 1) {
        return;
      }
      this.intervalId = setInterval(() => {
        this.rotateToNext();
      }, this.interval);
    },
    stopRotation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    rotateToNext() {
      if (!this.activeAgents || this.activeAgents.length === 0) {
        return;
      }
      this.currentIndex = (this.currentIndex + 1) % this.activeAgents.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.agent-status-carousel {
  position: relative;
  height: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 20px;

  .carousel-item {
    position: absolute;
    left: 0;
    right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;

    .agent-name {
      font-weight: 500;
      flex-shrink: 0;
    }

    .separator {
      flex-shrink: 0;
      margin: 0 2px;
    }

    .status-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ellipsis {
      flex-shrink: 0;
      margin-left: 2px;
    }
  }
}

// 上下翻转动画（垂直翻转）
.flip-enter-active,
.flip-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

// 从下方翻入
.flip-enter {
  transform: translateY(100%) scaleY(0);
  opacity: 0;
}

.flip-enter-to {
  transform: translateY(0) scaleY(1);
  opacity: 1;
}

// 向上方翻出
.flip-leave {
  transform: translateY(0) scaleY(1);
  opacity: 1;
}

.flip-leave-to {
  transform: translateY(-100%) scaleY(0);
  opacity: 0;
}
</style>
